module.exports = __webpack_public_path__ + "static/media/Lauren Kopchik Head Shot.ac2c1971.jpeg";